import { render } from "./index.vue?vue&type=template&id=12ee0164&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=12ee0164&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ee0164"],['__file',"src/components/Paginacao/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12ee0164"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12ee0164', __exports__)) {
    console.log('reload')
    api.reload('12ee0164', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=12ee0164&scoped=true", () => {
    console.log('re-render')
    api.rerender('12ee0164', render)
  })

}


export default __exports__